import React, { useState } from 'react'
import KickoutMemberModal from './KickoutMemberModal'
import I18n from 'i18n-js'

import Button from './Button'

function KickoutMemberButton ({ user_name: userName, kickout_member_path: kickoutMemberPath }) {
  const [isOpen, setModalOpen] = useState(false)

  return (
    <React.Fragment>
      <KickoutMemberModal isOpen={isOpen} onClose={() => setModalOpen(false)} userName={userName} kickoutMemberPath={kickoutMemberPath} />
      <Button className="community__kickoutMemberButton" iconBaseName="iconDelete" onlyIcon onClick={() => setModalOpen(true)} />
    </React.Fragment>
  )
}

export default KickoutMemberButton
